let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fcEu0")).then(() => parcelRequire('gaBfD'));